import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button, Col, Form, Row,
} from 'react-bootstrap';

export default class SocialButtonsBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = { new_rel: { type: 'download_pc' } };
        this.buttons_types = [
            { id: 'download_pc', name: 'Скачать' },
            { id: 'download', name: 'Скачать (1link ссылка для клиентских игр)' },
            { id: 'play', name: 'Играть' },
            { id: 'play_rustore', name: 'Ru Store' },
            { id: 'play_mymail', name: 'Мой мир' },
            { id: 'play_facebook', name: 'Facebook' },
            { id: 'play_vk', name: 'Вконтакте' },
            { id: 'play_odk', name: 'Одноклассники' },
            { id: 'play_appstore', name: 'App Store' },
            { id: 'play_osx', name: 'OS X' },
            { id: 'play_winstore', name: 'Windows Store' },
            { id: 'play_googleplay', name: 'Google Play' },
            { id: 'play_java', name: 'Java' },
            { id: 'buy_pc', name: 'Купить - PC' },
            { id: 'buy_ps4', name: 'Купить - PS4' },
            { id: 'buy_xboxone', name: 'Купить - Xbox one' },
            { id: 'play_igraem_rf', name: 'Играем РФ' },
        ];

        this.updateButton = this.updateButton.bind(this);
        this.createButton = this.createButton.bind(this);
        this.delButton = this.delButton.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const current_state = this.state;
        const elem_name = event.target.id.split('__')[0];
        const url_id = event.target.id.split('__')[1];
        let url_obj = {};
        let new_value = event.target.value;
        const { index } = event.currentTarget.dataset;

        if (url_id) {
            url_obj = current_state.data[index];
        }

        if (event.target.type === 'checkbox') {
            new_value = event.target.checked;
        }

        url_obj[elem_name] = new_value;

        if (!url_id) {
            if (!current_state.new_rel) {
                current_state.new_rel = {};
            }

            current_state.new_rel[elem_name] = new_value;
        }

        this.setState(current_state);
    }

    componentDidMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            new_rel: {
                type: 'download_pc', title: '', url: '', is_hidden: false,
            },
            ...nextProps,
        });
    }

    getButtonOptions(id) {
        const button_options = [];
        const button_obj = this.buttons_types.filter((x) => x.id === id)[0];

        for (let r = 0; r < this.buttons_types.length; r++) {
            if (!button_obj) {
                button_options.push(<option
                    key={`option_${this.buttons_types[r].id}`}
                    value={this.buttons_types[r].id}
                >
                    {this.buttons_types[r].name}
                </option>);
            } else {
                button_options.push(<option
                    key={`option_${this.buttons_types[r].id}`}
                    value={this.buttons_types[r].id}
                >
                    {this.buttons_types[r].name}
                </option>);
            }
        }

        return button_options;
    }

    getButtons() {
        const rows = [];

        for (let r = 0; r < this.state.data.length; r++) {
            rows.push(
                <Row key={`dbutton__${this.state.data[r].id}`}>
                    <Col md={12}>
                        <Form inline>
                            <Form.Group controlId={`type__${this.state.data[r].id}`}>
                                <Form.Control
                                    onChange={this.handleChange}
                                    size="sm"
                                    as="select"
                                    placeholder="select"
                                    style={{ width: 200 }}
                                    value={this.state.data[r].type}
                                    data-index={r}
                                >
                                    {this.getButtonOptions(this.state.data[r].type)}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group controlId={`url__${this.state.data[r].id}`}>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    onChange={this.handleChange}
                                    value={this.state.data[r].url}
                                    data-index={r}
                                />
                            </Form.Group>
                            <Form.Group controlId={`title__${this.state.data[r].id}`}>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.data[r].title}
                                    data-index={r}
                                />
                            </Form.Group>
                            <Form.Group controlId={`is_hidden__${this.state.data[r].id}`}>
                                <Form.Check
                                    type="checkbox"
                                    id={`is_hidden__${this.state.data[r].id}`}
                                    name={`is_hidden__${this.state.data[r].id}`}
                                    checked={this.state.data[r].is_hidden}
                                    onChange={this.handleChange}
                                    label="Скрыть"
                                    data-index={r}
                                />

                            </Form.Group>
                            <Form.Group controlId="control_buttons">
                                <Button
                                    size="sm"
                                    variant="outline-secondary"
                                    id={this.state.data[r].id}
                                    onClick={this.delButton}
                                    data-index={r}
                                >
                                    <FontAwesomeIcon icon="trash" />
                                </Button>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>,
            );
        }

        return rows;
    }

    createButton() {
        const data = this.state.new_rel;
        data.game_id = this.props.game;

        if (data && data.url.includes('store.steampowered') && !this.state.data.find((button) => button.type === 'cloud')) {
            const additionalData = {
                game_id: this.props.game,
                is_hidden: false,
                title: 'Играть в облаке',
                type: 'cloud',
                url: 'https://cloud.my.games/?_1ld=3275887_1&_1lp=1&utm_source=playerone&utm_campaign=revshare&utm_medium=playincloudbutton',
            };

            this.props.updater('add', additionalData);
        }

        this.props.updater('add', data);
    }

    updateButton(event) {
        const data_obj = this.state.data.filter((x) => x.id === parseInt(event.target.id))[0];
        this.props.updater('update', data_obj);
    }

    handleItemAdd = () => {
        const { updater, data } = this.props;

        updater([
            ...data,
            {
                type: 'download_pc',
            },
        ]);
    };

    delButton(event) {
        const { data, updater } = this.props;
        debugger;
        const newList = data.filter((item, i) => i !== +event.currentTarget.dataset.index);

        updater(newList);
    }

    render() {
        if (!this.state) {
            return null;
        }

        if (!this.state.data) {
            return null;
        }

        return (
            <div>
                <Form.Label> Кнопки </Form.Label>
                {this.getButtons()}
                <button
                    className="game-releases__add"
                    onClick={this.handleItemAdd}
                    type="button"
                >
                    +
                </button>
            </div>
        );
    }
}
